import React, { useState } from "react";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";
import { Controlled } from "react-codemirror2";
import { FiMinimize2, FiMaximize2 } from "react-icons/fi";
import { IoLogoHtml5, IoLogoCss3 } from "react-icons/io";
import { IoLogoJavascript } from "react-icons/io5";

export default function Editor({ title, lang, onChange, value }) {
  const [open, setOpen] = useState(true);

  const handlechange = (editor, data, value) => onChange(value);

  return (
    <div className={`editors-container ${open ? "" : "closed"}`}>
      <div className="title">
        {title === "JS" ? (
          <IoLogoJavascript size={20} style={{ color: "#f7df1e " }} />
        ) : title === "HTML" ? (
          <IoLogoHtml5 size={20} style={{ color: "#e34c26" }} />
        ) : title === "CSS" ? (
          <IoLogoCss3 size={20} style={{ color: "#264de4 " }} />
        ) : (
          title
        )}
        <button type="button" onClick={() => setOpen(!open)} className="button">
          {open ? <FiMinimize2 size={16} /> : <FiMaximize2 size={16} />}
        </button>
      </div>

      <Controlled
        onBeforeChange={handlechange}
        value={value}
        className="code-mirror-wrapper"
        options={{
          lineWrapping: true,
          lint: true,
          mode: lang,
          theme: "dracula",
          lineNumbers: true,
          smartIndent:true,
          electricChars:true,
          dragDrop:true,
          allowDropFileTypes:[`text/${lang==="xml"?"html":lang}`]
        }}
      />
    </div>
  );
}
